import { useState } from 'react'
import { useIntl } from 'react-intl'
import { FormikHelpers } from 'formik'
import { useHistory } from 'react-router-dom'
import { mdiCheckCircleOutline } from '@mdi/js'

import theme from 'theme_'
import { useAppDispatch } from 'app/hooks'
import { passInitResetThunk } from './slice'

import { MdiIcon } from 'components/Icons'
import CommonButton from 'components/Button/CommonButton'
import { ForgotPasswordFormValues } from './types'
import LoginCommonLayout from './components/LoginCommonLayout'
import ForgotPasswordForm from './components/ForgotPasswordForm/ForgotPasswordForm'
import { StyledMainHeading } from './components/MainHeading/MainHeading'
import { loginMessages } from './messages'
import { StyledDescriptionText, CheckMarkWrapper } from './styles'
import { SubmitLoginWrapper } from './components/LoginForm/styles'

function ForgotPassword() {
  const dispatch = useAppDispatch()
  const { formatMessage } = useIntl()
  const history = useHistory()
  const [formSubmitted, setFormSubmitted] = useState(false)

  const handleSubmit = (
    values: ForgotPasswordFormValues,
    formikHelpers: FormikHelpers<ForgotPasswordFormValues>
  ) => {
    const { email } = values
    dispatch(
      passInitResetThunk({
        email,
        onSuccess: () => {},
      })
    )
    setFormSubmitted(true)
  }

  if (formSubmitted) {
    return (
      <LoginCommonLayout>
        <StyledMainHeading>
          {formatMessage(loginMessages.forgotPasswordSubmittedHeading)}
        </StyledMainHeading>

        <CheckMarkWrapper>
          <MdiIcon
            path={mdiCheckCircleOutline}
            color={theme.colors.green}
            size={3}
          />
        </CheckMarkWrapper>

        <StyledDescriptionText>
          {formatMessage(loginMessages.forgotPasswordSubmittedDescription)}
        </StyledDescriptionText>

        <SubmitLoginWrapper>
          <CommonButton type="button" onClick={() => history.push('/')}>
            {formatMessage(loginMessages.goToSignInButton)}
          </CommonButton>
        </SubmitLoginWrapper>
      </LoginCommonLayout>
    )
  }

  return (
    <LoginCommonLayout>
      <StyledMainHeading>
        {formatMessage(loginMessages.forgotPasswordHeading)}
      </StyledMainHeading>
      <StyledDescriptionText>
        {formatMessage(loginMessages.forgotPasswordDescription)}
      </StyledDescriptionText>
      <ForgotPasswordForm handleSubmit={handleSubmit} />
    </LoginCommonLayout>
  )
}

export default ForgotPassword
